import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToasterComponent } from './components/common/ToastManager';
import RoleOverview from './components/RoleOverview';
import RoleDesignerHero from './components/RoleDesignerHero';
import CompanyProfile from './components/CompanyProfile';
import Timeline from './components/Timeline';
import Responsibilities from './components/Responsibilities';
import Outcomes from './components/Outcomes';
import SwaggerDocs from './pages/SwaggerDocs';
import RoleViewerPage from './pages/RoleViewerPage';
import { FormProvider, useFormContext } from './contexts/FormContext';
import OutputsSection from './components/outputs/OutputsSection';
import ModeToggle from './components/ModeToggle';
import ProModeSection from './components/ProModeSection';

// Create a separate component for the main app content
const AppContent = () => {
  const { isProMode, toggleProMode } = useFormContext();

  return (
    <div className="App">
      <ToasterComponent />
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-5xl mx-auto mb-8">
          <div className="flex justify-between items-center">
            <a href="/" className="flex items-center">
              <img
                src="/predicthire.png"
                alt="PredictHire"
                className="h-8 w-auto"
              />
            </a>
            <div className="flex items-center gap-4">
              <ModeToggle
                isProMode={isProMode}
                setIsProMode={toggleProMode}
              />
              <div className="flex items-center">
                <a
                  href="https://app.predicthire.com/signin"
                  className="py-3 text-base font-medium px-7 text-gray-800 hover:text-blue-600 transition-colors"
                >
                  Login
                </a>
                <a
                  href="https://app.predicthire.com/register"
                  className="py-3 text-base font-medium text-white rounded-md bg-blue-600 px-7 hover:bg-blue-700 transition-colors"
                >
                  Sign Up
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <RoleDesignerHero />
          <CompanyProfile />
          <RoleOverview />
          {isProMode ? (
            <>
              <Timeline />
              <div className="max-w-5xl mx-auto space-y-4">
                <Responsibilities />
                <Outcomes />
              </div>
            </>
          ) : (
            <ProModeSection onEnableProMode={() => toggleProMode()} />
          )}
          <OutputsSection isProMode={isProMode} />
        </div>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <FormProvider>
        <Routes>
          <Route path="/api-docs" element={<SwaggerDocs />} />
          <Route path="/roles/:company/:role" element={<RoleViewerPage />} />
          <Route path="/" element={<AppContent />} />
        </Routes>
      </FormProvider>
    </Router>
  );
}

export default App;